<div class="green-number">
  <header role="banner" class="green-number__header">
    <div class="green-number__header__content">
      <h2 role="heading" class="green-number__header__title">
        {{ title }}
      </h2>
      <p class="green-number__header__subtitle">{{ text }}</p>
    </div>
  </header>
  <div class="green-number__contact">
    <h3 role="heading" class="green-number__contact__title">Contactez-nous&nbsp;!</h3>
    <div class="green-number__contact__phone-number">
      <mat-icon
        class="green-number__contact__phone-number__icon"
        svgIcon="phone"
        role="presentation"
        aria-hidden="true"
      ></mat-icon>
      <hr class="green-number__contact__phone-number__divider" />
      <a
        class="green-number__contact__phone-number__link"
        href="tel:0801010808"
        aria-label="Contactez-nous au 0 801 010 808"
        >0&nbsp;801&nbsp;010&nbsp;808</a
      >
    </div>
    <p class="green-number__contact__description">
      <strong>Appel gratuit </strong>
      <span class="line-break">Du lundi au vendredi entre 8h et 17h</span>
    </p>
  </div>
</div>
